import { RowWithId } from '@/components/table/types/RowWithId.ts';
import { MessageStatus } from '@/features/dashboard/messages/types/MessageEnums.ts';
import { MessageStatusDto } from '@/features/dashboard/messages/types/MessageStatusDto.ts';

/** Kolumna `status` niesie parę wysyłka + doręczenie; menu wiersza patrzy tylko na wysyłkę. */
export const messageRowSendStatus = (
  row: RowWithId,
): MessageStatus | undefined =>
  (row as unknown as { status?: MessageStatusDto }).status?.sendStatus;

/** Anulować da się tylko to, co jeszcze czeka w kolejce — wysłanej ani przepadłej już nie zatrzymamy. */
export const canCancelMessageRow = (row: RowWithId): boolean => {
  const sendStatus = messageRowSendStatus(row);
  return (
    sendStatus === MessageStatus.SCHEDULED ||
    sendStatus === MessageStatus.SCHEDULED_FOR_RETRY
  );
};

/** Ponowienie ma sens dopiero po wyczerpaniu prób; wcześniej backend odpowiada 409. */
export const canRetryMessageRow = (row: RowWithId): boolean =>
  messageRowSendStatus(row) === MessageStatus.FAILED;
